/* Rquiere de mixin.js */

var label = {
	data() {
		return {
			listLabels: [],
			methodsLabel: {
				show: 'label/',
				get: 'labels',
				create: 'label/register',
				delete: '/delete',
				update: '/update'
			},
			paginationLabels: [],
			searchLabels: '',
			objectLabel: {},
			listVariablesF: [],
			selectedLabelId: 0,
			searchingLabels: false,
			qRowsLabel: 25
		}
	},
	computed: {
		listVariables() {
			let result = []
			let str = (this.objectLabel.zpl == undefined) ? '' : this.objectLabel.zpl
			let search_1 = '{{'
			let search_2 = '}}'
			let begin = 0
			let variable
			while (begin != -1 && str.length > 0) {
				begin = str.indexOf(search_1)
				if (begin > -1) {
					str = str.substr(begin + search_1.length, str.length - begin - search_1.length)
					begin = str.indexOf(search_2)
					if (begin > -1) {
						variable = str.substr(0, begin)
						let index = result.map((el) => el.name).indexOf(variable.trim())
						if (index == -1) {
							result.push({ 'name': variable.trim(), 'val': '', 'original': search_1 + variable + search_2 })
						}
						str = str.substr(begin + search_2.length, str.length - begin - search_2.length)
					}
				}
			}
			this.listVariablesF = result
			return result
		}
	},
	filters: {
	},
	methods: {
		addListLabels(newLabel) {
			this.listLabels.unshift(newLabel)
		},
		clearObjectLabel() {
			this.objectLabel = {}
			this.objectLabel.id = 0
			this.objectLabel.name = ''
			this.objectLabel.zpl = ''
			this.objectLabel.status_id = 1
		},
		clearListVariablesF() {
			this.listVariablesF.forEach(element => { element.val = '' })
		},
		deleteItemListLabels(id) {
			let index = this.listLabels.map((el) => parseInt(el.id)).indexOf(parseInt(id))
			console.log(index)
			let labelDeleted = this.listLabels.splice(index, 1)
		},
		deleteLabel(id) {
			if (confirm('Está seguro que quiere eliminar la etiqueta Nº ' + id)) {
				this.$emit('showLockScreen', 'Borrando solicitud de envío . . .')
				this.axiosActionIS(this.getApiBackend + this.methodsLabel.show + id + this.methodsLabel.delete, 'DELETE', 'resultDeleteLabel')
			}
		},
		getAllLabels(page = 1) {
			this.listLabels = []
			this.paginationLabels = []
			this.searchingLabels = true
			let parameters = '?search=' + this.searchLabels + '&page=' + page + '&qRow=' + this.qRowsLabel
			let url = this.getApiBackend + this.methodsLabel.get + parameters
			this.axiosActionIS(url, 'GET', 'resultGetAllLabels')
		},
		initMixinLabel() {
			this.clearObjectLabel()
			this.setListeningLabel()
		},
		resultAxiosLocalLabel(responseLocal, response) {
			this.$emit('hideLockScreen')
			switch (responseLocal) {
				case 'resultDeleteLabel': this.resultDeleteLabel(response); break;
				case 'resultGetAllLabels': this.resultGetAllLabels(response); break;
				case 'resultSaveLabelPOST': this.resultSaveLabel(response, responseLocal); break;
				case 'resultSaveLabelPUT': this.resultSaveLabel(response, responseLocal); break;
				case 'resultShowLabelGET': this.resultShowLabelGET(response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
		},
		resultDeleteLabel(response) {
			if (response.data.success) {
				this.deleteItemListLabels(response.data.data)
				this.socketEmit(['DELETE_LABEL'], response.data.data)
			}
		},
		resultGetAllLabels(response) {
			this.searchingLabels = false
			if (response.data.success == true) {
				this.listLabels = response.data.data
				this.paginationLabels = response.data.paginate
			}
		},
		resultSaveLabel(response, responseLocal) {
			if (response.data.success) {
				if (responseLocal == 'resultSaveLabelPOST') {
					this.addListLabels(response.data.data)
					this.socketEmit(['NEW_LABEL'], response.data.data)
				} else if (responseLocal == 'resultSaveLabelPUT') {
					this.updateItemListLabels(response.data.data)
					this.socketEmit(['UPDATE_LABEL'], response.data.data)
				}
				console.log('Guardado con exito')
			} else {
				console.log(response)
				this.setErrorSaveUserLocal(response)
			}
		},
		resultShowLabelGET(response) {
			this.objectLabel = response.data.data
			this.listVariables
			this.showLabelResultLocal(response)
		},
		showLabelResultLocal(response) {
			console.log('showLabelResultLocal no desarrollado', response)
		},
		replaceZPLVariableFromArray(arrayZPL) {
			this.clearListVariablesF()
			Object.values(arrayZPL).forEach(val => {
				let index = this.listVariablesF.map((el) => el.name).indexOf(val.name)
				if (index > -1) this.listVariablesF[index].val = val.value
			});
		},
		saveLabel() {
			let method = (this.objectLabel.id == 0) ? 'POST' : 'PUT'

			this.$emit('showLockScreen', 'Guardando datos . . .')
			if (method == 'POST') {
				this.axiosActionIS(this.getApiBackend + this.methodsLabel.create, method, 'resultSaveLabelPOST', this.objectLabel)
			} else if (method == 'PUT') {
				let url = this.getApiBackend + this.methodsLabel.show + this.objectLabel.id + this.methodsLabel.update
				this.axiosActionIS(url, method, 'resultSaveLabelPUT', this.objectLabel)
			}
		},
		selectedLabel(index) {
			this.objectLabel = this.listLabels[index]
		},
		setLabelOfListLabel(index, data) {
			this.listLabels[index].name = data.name
			this.listLabels[index].zpl = data.zpl
			this.listLabels[index].status_id = data.status_id
			this.listLabels[index].status = data.status
		},
		setListeningLabel() {
			this.sockets.subscribe('DELETE_LABEL', (data) => { this.deleteItemListLabels(data.body) })
			this.sockets.subscribe('NEW_LABEL', (data) => { this.addListLabels(data.body) })
			this.sockets.subscribe('UPDATE_LABEL', (data) => { this.updateItemListLabels(data.body) })
		},
		showLabel(id) {
			this.$emit('showLockScreen', 'Buscando etiqueta . . .')
			this.axiosActionIS(this.getApiBackend + this.methodsLabel.show + id, 'GET', 'resultShowLabelGET', null)
		},
		toPrintTest() {
			if (this.listVariablesF.length > 0) {
				this.$refs.openLabelVariablesModal.click()
			} else {
				this.toPrintWebSocketServer(this.objectLabel.zpl)
			}
		},
		toPrintWithVariables() {
			let variable = this.objectLabel.zpl
			this.listVariablesF.forEach(element => {
				variable = variable.replace(new RegExp(element.original, "gi"), element.val)
			});
			this.toPrintWebSocketServer(variable)
		},
		updateItemListLabels(data) {
			let index = this.listLabels.map((el) => el.id).indexOf(data.id)
			this.setLabelOfListLabel(index, data)
		}
	},
	mounted() {
		this.initMixinLabel();
	},
};

export default label;